import Api from "./PreApiHandler";

const CohortsService = {
  async list() {
    try {
      const data = await Api.sendRequest({ method: 'get', path: 'cohorts' })
      return data?.items || data || []
    } catch (e) {
      return []
    }
  },

  async create(payload) {
    return Api.sendRequest({ method: 'post', path: 'cohorts', body: payload })
  },

  async update(id, payload) {
    return Api.sendRequest({ method: 'post', path: `cohorts/${id}`, body: payload })
  },

  async remove(id) {
    return Api.sendRequest({ method: 'delete', path: `cohorts/${id}` })
  },

  async getUsers(id, { page = 1, perPage = 50, resourceKey = null } = {}) {
    return Api.sendRequest({
      method: 'get',
      path: `cohorts/${id}/users`,
      params: { page, per_page: perPage, ...(resourceKey ? { resource_key: resourceKey } : {}) },
    })
  },

  async userProfiles(userIds, resourceKey = null) {
    return Api.sendRequest({
      method: 'post',
      path: 'cohorts/user-profiles',
      body: { user_ids: userIds, ...(resourceKey ? { resource_key: resourceKey } : {}) },
    })
  },
}

export default CohortsService
